import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=f4f10bea&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4f10bea')) {
      api.createRecord('f4f10bea', component.options)
    } else {
      api.reload('f4f10bea', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=f4f10bea&", function () {
      api.rerender('f4f10bea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/countries/cities/edit.vue"
export default component.exports